import {
  CREATE_LEAGUE_ERROR,
  CREATE_LEAGUE_LOADING,
  CREATE_LEAGUE_SUCCESS,
  CREATE_TOURNAMENT_ERROR,
  CREATE_TOURNAMENT_LOADING,
  CREATE_TOURNAMENT_SUCCESS,
} from "../../../constant/actionTypes";

const createTournamentReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_TOURNAMENT_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case CREATE_TOURNAMENT_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case CREATE_TOURNAMENT_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default createTournamentReducer;
